import classNames from 'classnames'
import { observable, runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import GlobalState, {
  changeCareerCoopState,
  changeCoopState,
} from '../../../../stores/GlobalState'
import { ReactComponent as Logo } from '../../../../assets/about/small-logo.svg'
import { ReactComponent as Close } from '../../../../assets/track/close.svg'
import { CoopInput, EmailInput } from '../../../common/CoopPop'
import SubList from '../../about/SubList'
import TextareaAutosize from 'react-textarea-autosize'
import { ReactComponent as Share } from '../../../../assets/track/link01.svg'
import { TrackingFlag } from '../../tracking/TrackingContent'
import LangList from '../../reg/LangList'
import { ReactComponent as Arrow } from '../../../../assets/login/Rectangle 30.svg'
import PhoneInput from '../PhoneInput'
import './index.scss'
import { useLocation } from 'react-router'

export const CountriesStore: any = observable({
  list: null,
})

const CoopPop = observer(() => {
  const { pathname } = useLocation()
  const list = GlobalState.currentLocale.lang.includes('En')
    ? CountriesStore.list?.en
    : GlobalState.currentLocale.lang.includes('ру')
    ? CountriesStore.list?.ru
    : CountriesStore.list?.uk
  const [showMod, setShow] = useState(false)
  const [width, setWidth] = useState(window.innerWidth)

  let ukrIndex = 0
  CountriesStore.list?.en?.forEach((element: any, i: number) => {
    if (element.country == 'Ukraine') {
      ukrIndex = i
      return
    }
  })

  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    lang: {
      icon: CountriesStore.list?.en[ukrIndex].flag || '',
      lang: GlobalState.currentLocale.lang.includes('En')
        ? 'Ukraine'
        : GlobalState.currentLocale.lang.includes('ру')
        ? 'Украина'
        : 'Україна' || '',
    },
    social: '',
    salary: '',
    letter: '',
    file: undefined,
  })

  const [errs, setErrs] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
  })
  useEffect(() => {
    let vh = window.innerHeight * 0.01
    const screens = document.querySelector('.coop-pop')
    ;(screens as HTMLElement)?.style.setProperty('--vh', `${vh}px`)
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth)
      let vh = window.innerHeight * 0.01
      const screens = document.querySelector('.coop-pop')
      ;(screens as HTMLElement)?.style.setProperty('--vh', `${vh}px`)
    })
  }, [])

  useEffect(() => {
    if (GlobalState.isCareerCoopShow) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isCareerCoopShow])

  const change = (showMod: boolean) => {
    document.querySelector('.coop-pop')?.classList.remove('show')
    document.querySelector('.coop-pop')?.classList.add('close')

    if (!showMod) {
      setTimeout(() => {
        document.querySelector('.coop-pop')?.classList.add('hidden-pop')
      }, 300)
      setTimeout(() => {
        changeCareerCoopState()
      }, 500)
    }
  }

  useEffect(() => {
    if (!showMod) return

    setTimeout(() => {
      const track = document.querySelector('.coop-pop__final-dash.left')
      if (!track) return
      track.classList.add('animated')

      const resizeObserver1 = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            if (entry.contentBoxSize[0]) {
              if (width > 768) {
                const width = entry.contentBoxSize[0].inlineSize
                const parentWidth = track.parentElement!.getBoundingClientRect()
                  .width

                const right = document.querySelector(
                  '.coop-pop__final-dash.right',
                )
                if (!right) return

                if (width == parentWidth || width / parentWidth > 0.9) {
                  right.classList.add('animated')
                }
              } else {
                const height = entry.contentBoxSize[0].blockSize
                const parentWidth = track.parentElement!.getBoundingClientRect()
                  .height

                const right = document.querySelector(
                  '.coop-pop__final-dash.right',
                )
                if (!right) return
                if (height == parentWidth || height / parentWidth > 0.9) {
                  right.classList.add('animated')
                }
              }
            }
          }
        }
      })
      resizeObserver1.observe(track)

      const track2 = document.querySelector('.coop-pop__final-dash.right')
      if (!track2) return

      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            if (entry.contentBoxSize[0]) {
              if (width > 768) {
                const width = entry.contentBoxSize[0].inlineSize
                const parentWidth = track2.parentElement!.getBoundingClientRect()
                  .width
                if (width == parentWidth || width / parentWidth > 0.9) {
                  setTimeout(() => {
                    document
                      .querySelector('.coop-pop')
                      ?.classList.add('hidden-pop')
                  }, 4000)

                  setTimeout(() => {
                    runInAction(() => {
                      GlobalState.isCoopShow = false
                    })
                  }, 4500)
                }
              } else {
                const height = entry.contentBoxSize[0].blockSize
                const parentWidth = track2.parentElement!.getBoundingClientRect()
                  .height

                if (height == parentWidth || height / parentWidth > 0.9) {
                  setTimeout(() => {
                    document
                      .querySelector('.coop-pop')
                      ?.classList.add('hidden-pop')
                  }, 4000)

                  setTimeout(() => {
                    runInAction(() => {
                      GlobalState.isCoopShow = false
                    })
                  }, 4500)
                }
              }
            }
          }
        }
      })
      resizeObserver.observe(track2)
    }, 300)
  }, [showMod])

  useEffect(() => {
    if (GlobalState.isCareerCoopShow)
      document.querySelector('.coop-pop')?.classList.add('show')
  }, [])
  const getFileSize = () => {
    const size = (state.file as any).size
    let res = 0,
      end = 'kb'
    if (size / 1000 > 1 && size / 1000000 < 1) {
      res = size / 1000
      end = 'kb'
    } else if (size / 1000000 > 1) {
      res = size / 1000000
      end = 'mb'
    }

    return `${res.toFixed(2)}${end}`
  }

  const isEmail = (email: string) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email,
    )
  }

  const submit = () => {
    const ers = {
      firstName: state.firstName.length
        ? ''
        : ContentState.career.coop.emptyField,
      lastName: state.lastName.length
        ? ''
        : ContentState.career.coop.emptyField,
      phone: state.phone.length ? '' : ContentState.career.coop.emptyField,
      email:
        state.email.length && !isEmail(state.email)
          ? ContentState.career.coop.incorrect
          : !state.email.length
          ? ContentState.career.coop.emptyField
          : '',
    }

    if (
      ers.firstName.length ||
      ers.lastName.length ||
      ers.email.length ||
      ers.phone.length
    ) {
      setErrs({ ...errs, ...ers })
      return
    }

    const fd = new FormData()
    fd.append('firstName', state.firstName)
    fd.append('lastName', state.lastName)
    fd.append('phone', state.phone)
    fd.append('letter', state.letter)
    fd.append('salary', state.salary)
    fd.append('social', state.social)
    fd.append('lang', state.lang.lang)
    state.file && fd.append('file', state.file!, (state.file as any).name)
    fd.append('email', state.email)
    fd.append('career', '1')
    fd.append('status', 'coop')
    fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    }).then(() => {
      ;(window as any).dataLayer = (window as any).dataLayer || []
      ;(window as any).dataLayer.push({ event: 'resume_form' })

      change(true)
      setShow(true)
    })
  }

  useEffect(() => {
    const ers = {
      firstName: errs.firstName,
      lastName: errs.lastName,
      phone: errs.phone,
      email: errs.email,
    }

    if (state.firstName.length) {
      ers.firstName = ''
    }
    if (state.lastName.length) {
      ers.lastName = ''
    }
    if (state.phone.length) {
      ers.phone = ''
    }
    if (state.email.length && isEmail(state.email)) {
      ers.email = ''
    }
    setErrs({ ...errs, ...ers })
  }, [state.lastName, state.phone, state.email, state.firstName])

  return (
    <section
      className={classNames('coop-pop career', showMod && 'modal')}
      onClick={() => {
        if (!showMod) {
          change(showMod)
        }
      }}
    >
      {!showMod ? (
        <div
          className="coop-pop__container"
          onClick={(e) => e.stopPropagation()}
        >
          <form
            className={classNames('coop-pop__cont animate')}
            autoComplete="off"
          >
            <div
              onClick={() => {
                change(showMod)
              }}
              className="coop-pop__close"
            >
              <Close />
            </div>

            <div
              className="coop-pop__title"
              dangerouslySetInnerHTML={{
                __html: ContentState.career.coop.title,
              }}
            ></div>
            <div
              className="coop-pop__text"
              dangerouslySetInnerHTML={{
                __html: ContentState.career.coop.text,
              }}
            ></div>

            <div className={classNames('coop-pop__row')}>
              <div className="coop-pop__col">
                <CoopInput
                  isEmail={false}
                  wordCheck={true}
                  phoneCheck={false}
                  label={ContentState.career.coop.firstname}
                  errs={errs.firstName}
                  state={state.firstName}
                  setState={(value) => setState({ ...state, firstName: value })}
                />
                <CoopInput
                  isEmail={false}
                  wordCheck={true}
                  phoneCheck={false}
                  label={ContentState.career.coop.lastname}
                  errs={errs.lastName}
                  state={state.lastName}
                  setState={(value) => setState({ ...state, lastName: value })}
                />
                <PhoneInput
                  state={state.phone}
                  setValue={(value) => setState({ ...state, phone: value })}
                  placeholder={ContentState.career.coop.phone}
                  error={errs.phone}
                />
                <EmailInput
                  label={'Email'}
                  errs={errs.email}
                  state={state.email}
                  setState={(value) => {
                    setState({ ...state, email: value })
                  }}
                />
                <LangList
                  dt={list}
                  state={state.lang}
                  setState={(value) => {
                    setState({ ...state, lang: value })
                  }}
                />
                <CoopInput
                  isEmail={false}
                  wordCheck={false}
                  phoneCheck={false}
                  label={ContentState.career.coop.social}
                  errs={''}
                  state={state.social}
                  setState={(value) => setState({ ...state, social: value })}
                />
                <CoopInput
                  isEmail={false}
                  wordCheck={false}
                  phoneCheck={false}
                  label={ContentState.career.coop.salary}
                  errs={''}
                  state={state.salary}
                  setState={(value) => setState({ ...state, salary: value })}
                />
              </div>
            </div>
            <div
              className={classNames(
                'coop-pop__input msg-block',
                state.letter.length && 'fill',
              )}
            >
              <label>
                <span className="coop-pop__label textarea">
                  {ContentState.career.coop.yourmessage}
                </span>
                <TextareaAutosize
                  maxRows={5}
                  onChange={(e) =>
                    setState({ ...state, letter: e.target.value })
                  }
                ></TextareaAutosize>
              </label>
            </div>
            <div className="coop-pop__bottom-block">
              {!state.file && (
                <label className="button white grey-border">
                  <Share />
                  {ContentState.career.coop.addfile}
                  <input
                    type={'file'}
                    accept=".doc,.docx,.pdf"
                    onChange={(e) => {
                      if (!e.target!.files) return
                      setState({ ...state, file: (e.target!.files[0] as any)! })
                    }}
                  />
                </label>
              )}
              {state.file && (
                <div className="coop-pop__file">
                  <div className="coop-pop__file-name">
                    {(state.file as any)?.name.length > 27
                      ? `${(state.file as any)?.name.slice(0, 27)}...`
                      : (state.file as any)?.name}
                  </div>
                  <div className="coop-pop__file-size">{getFileSize()}</div>
                  <div
                    className="coop-pop__file-del"
                    onClick={() => {
                      setState({ ...state, file: undefined })
                    }}
                  >
                    <Close />
                  </div>
                </div>
              )}
              {errs.firstName.length ||
              errs.lastName.length ||
              errs.phone.length ||
              errs.email.length ? (
                <div className="coop-pop__errors">
                  {errs.firstName.length ? (
                    <div className="coop-pop__error">{errs.firstName}</div>
                  ) : (
                    <></>
                  )}
                  {errs.lastName.length ? (
                    <div className="coop-pop__error">{errs.lastName}</div>
                  ) : (
                    <></>
                  )}
                  {errs.phone.length ? (
                    <div className="coop-pop__error">{errs.phone}</div>
                  ) : (
                    <></>
                  )}
                  {errs.email.length ? (
                    <div className="coop-pop__error">{errs.email}</div>
                  ) : (
                    <></>
                  )}{' '}
                </div>
              ) : (
                <></>
              )}
              <div className="button black" onClick={submit}>
                {ContentState.career.coop.send}
              </div>
            </div>
          </form>
        </div>
      ) : (
        <></>
      )}
      <section
        className={classNames(
          'coop-pop__final',
          showMod && 'show',
          !showMod && 'hidden',
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          onClick={() => {
            document.querySelector('.coop-pop__final')?.classList.add('hidden')
            setTimeout(() => {
              changeCoopState()
            }, 500)
          }}
          className="coop-pop__close"
        >
          <Close />
        </div>
        <div className="coop-pop__final-top">
          <div className="coop-pop__final-line">
            <div className="coop-pop__final-dash left"></div>
          </div>
          <div className="coop-pop__final-middle">
            <Logo className="coop-pop__final-logo" />
            {ContentState.career.thanks.title}
          </div>
          {width <= 768 && (
            <div className="coop-pop__final-text">
              {ContentState.career.thanks.text}
            </div>
          )}
          <div className="coop-pop__final-line">
            <div className="coop-pop__final-dash right"></div>
          </div>
        </div>
        {width > 768 && (
          <div className="coop-pop__final-text">
            {ContentState.career.thanks.text}
          </div>
        )}
      </section>
    </section>
  )
})

export default CoopPop
